"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const environment_1 = require("@environment/environment");
window.SentryUtils = {
    feedbackWidget: null,
    init: function () {
        if (!window.Sentry) {
            console.warn("[Sentry] Not available");
            return;
        }
        console.log("[Sentry] Initializing...");
        window.Sentry.init({
            dsn: "https://a7269f99ec7be80eb55563d14e8ee918@o4508330685628416.ingest.us.sentry.io/4508369744560128",
            environment: environment_1.environment.sentryEnvironment,
            // ✅ Explicitly disable feedback
            integrations: [],
        });
        this.setUser();
        try {
            var navEntries = (performance && typeof performance.getEntriesByType === "function")
                ? performance.getEntriesByType("navigation")
                : [];
            var isReload = false;
            if (navEntries && navEntries.length > 0 && navEntries[0] && navEntries[0].type === "reload") {
                isReload = true;
            }
            else if (performance && performance.navigation && performance.navigation.type === 1) {
                isReload = true;
            }
            if (isReload) {
                console.log("This page was reloaded!");
                if (window.Sentry && typeof window.Sentry.captureMessage === "function") {
                    var additionalData = {
                        agentId: localStorage.getItem('userId') || '',
                        agentName: (localStorage.getItem("first_name") || "") + " " + (localStorage.getItem("last_name") || ""),
                        timestamp: new Date().toLocaleString('en-US', { timeZone: 'UTC', hour12: false })
                    };
                    window.Sentry.captureMessage("Browser Page Reload", {
                        level: "info",
                        tags: { navigation_type: "reload" },
                        extra: Object.assign(Object.assign({}, additionalData), { url: window.location && window.location.href, referrer: document && document.referrer })
                    });
                }
            }
        }
        catch (e) {
            console.warn("[Sentry] Reload detection failed", e);
        }
    },
    setUser: function () {
        if (!window.Sentry)
            return;
        var firstName = (localStorage.getItem("first_name") || "").trim();
        var lastName = (localStorage.getItem("last_name") || "").trim();
        var email = (localStorage.getItem("email") || "").trim();
        var username = (firstName + " " + lastName).trim();
        if (email || username) {
            window.Sentry.setUser({
                email: email || undefined,
                username: username || undefined,
            });
            console.log("[Sentry] User set:", { email, username });
        }
    }
};
